export { StartPage } from "./startpage";
export { ExperiencePage } from "./experience";
export { RelevencePage } from "./relevence";
export { RefreshPage } from "./refresh";
export { PlanningPage } from "./planning";
export { RiskPage } from "./risk";
export { BehaviourPage } from "./behaviour";
export { SustainabilityPage } from "./sustainability";
export { LiquidityPage } from "./liquidity";
export { SavingsPage } from "./savings";
export { SharesPage } from "./shares";
export { DebtPage } from "./debt";
export { RiskLevelPage } from "./risklevel";
export { AgreementDetailsPage } from "./agreementdetails";
export { SavingSuggestionPage } from "./savingsuggestion";
export { ExpectedValuePage } from "./expectedvalue";
export { CompleteSavingsPage } from "./completesaving";
export { FinalPage } from "./finalpage";
